import React from 'react';

import CmsElement from 'Components/Utilities/CmsElement';
import {Loading} from 'Components/Partials';
import {PrimaryButton} from 'Components/Button';
import {ModalTrigger} from 'Components/Modal';
import CreateCmsElementRecordModal from 'Components/Partials/Modals/CreateCmsElementRecordModal';

import {translation} from 'Services/TranslationHelpers';

export default class CelebrationWallTab extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'celebration-wall';

    /**
     * @var state
     */
    state = {
        working: true
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {working, element, records} = this.state;

        return (
            <div>
                {working && <Loading />}

                {!working && 
                    <ModalTrigger 
                        component={CreateCmsElementRecordModal}
                        props={{
                            showElementsDropdown: false,
                            element_id: element.id,
                            element_record_id: null
                        }}
                    >
                        <PrimaryButton
                            text="Add To Photo Wall"
                            className="mb-8"
                        />
                    </ModalTrigger>
                }
            </div>
        );
    }
}
